/** @format */
import React, { FC } from 'react'

interface GrafanaIframeProps {
  className?: string
  src: string
  width?: string
  height?: string
  title?: string
}

const GrafanaIframe: FC<GrafanaIframeProps> = ({
  className,
  src,
  width = '100%',
  height = '100%',
  title = 'Grafana'
}) => {
  return (
    <div className={className} style={{ height, width }}>
      <iframe src={src} title={title} width="100%" height="100%" />
    </div>
  )
}

export default GrafanaIframe
